import React from 'react';
import { icons } from '@ublend-npm/aulaui-next';
import { Container } from './MimeTypeIcon.styled';

export const mimeTypeIcons: { [key: string]: JSX.Element } = {
  doc: <icons.Word />,
  dot: <icons.Word />,
  docx: <icons.Word />,
  dotx: <icons.Word />,
  docm: <icons.Word />,
  dotm: <icons.Word />,

  xls: <icons.Excel />,
  xlt: <icons.Excel />,
  xla: <icons.Excel />,
  xlsx: <icons.Excel />,
  xltx: <icons.Excel />,
  xlsm: <icons.Excel />,
  xltm: <icons.Excel />,
  xlam: <icons.Excel />,
  xlsb: <icons.Excel />,

  ppt: <icons.Ppt />,
  pot: <icons.Ppt />,
  pps: <icons.Ppt />,
  ppa: <icons.Ppt />,
  pptx: <icons.Ppt />,
  potx: <icons.Ppt />,
  ppsx: <icons.Ppt />,
  ppam: <icons.Ppt />,
  pptm: <icons.Ppt />,
  potm: <icons.Ppt />,
  ppsm: <icons.Ppt />,

  aa: <icons.MusicNoteIcon />,
  aac: <icons.MusicNoteIcon />,
  aax: <icons.MusicNoteIcon />,
  act: <icons.MusicNoteIcon />,
  aiff: <icons.MusicNoteIcon />,
  amr: <icons.MusicNoteIcon />,
  ape: <icons.MusicNoteIcon />,
  au: <icons.MusicNoteIcon />,
  awb: <icons.MusicNoteIcon />,
  dct: <icons.MusicNoteIcon />,
  dss: <icons.MusicNoteIcon />,
  dvf: <icons.MusicNoteIcon />,
  flac: <icons.MusicNoteIcon />,
  gsm: <icons.MusicNoteIcon />,
  iklax: <icons.MusicNoteIcon />,
  ivs: <icons.MusicNoteIcon />,
  m4a: <icons.MusicNoteIcon />,
  m4b: <icons.MusicNoteIcon />,
  m4p: <icons.MusicNoteIcon />,
  mmf: <icons.MusicNoteIcon />,
  mp3: <icons.MusicNoteIcon />,
  mpc: <icons.MusicNoteIcon />,
  msv: <icons.MusicNoteIcon />,
  ogg: <icons.MusicNoteIcon />,
  opus: <icons.MusicNoteIcon />,
  ra: <icons.MusicNoteIcon />,
  raw: <icons.MusicNoteIcon />,
  sln: <icons.MusicNoteIcon />,
  tta: <icons.MusicNoteIcon />,
  vox: <icons.MusicNoteIcon />,
  wav: <icons.MusicNoteIcon />,
  webm: <icons.MusicNoteIcon />,
  wma: <icons.MusicNoteIcon />,
  wv: <icons.MusicNoteIcon />,

  '3g2': <icons.VideocamIcon />,
  '3gp': <icons.VideocamIcon />,
  asf: <icons.VideocamIcon />,
  avi: <icons.VideocamIcon />,
  flv: <icons.VideocamIcon />,
  m4v: <icons.VideocamIcon />,
  mov: <icons.VideocamIcon />,
  mp4: <icons.VideocamIcon />,
  mpg: <icons.VideocamIcon />,
  rm: <icons.VideocamIcon />,
  srt: <icons.VideocamIcon />,
  swf: <icons.VideocamIcon />,
  vob: <icons.VideocamIcon />,
  wmv: <icons.VideocamIcon />,

  pdf: <icons.PictureAsPdf />,

  png: <icons.Image />,
  jpg: <icons.Image />,

  generic: <icons.InsertDriveFileIcon />,
};

export type MimeTypeIconProps = {
  type: string | undefined;
};

export const MimeTypeIcon = ({ type }: MimeTypeIconProps) => (
  <Container>
    {!type
      ? mimeTypeIcons.generic
      : mimeTypeIcons[type.replace(/[^/]+\//, '')] || mimeTypeIcons.generic}
  </Container>
);
